import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'roo-ui/components';
import Currency from 'components/Currency';

// prettier-ignore
const OfferPayableAtProperty = ({ payableAtProperty, isIncludedInTotal }) =>
  Number(payableAtProperty.amount) > 0 && (
    <Box
      textAlign="left"
      mt={[0, 2]}
      mb={[4, 2]}
      color="greys.steel"
      lineHeight="tight"
      fontSize={['xs', 'sm']}
      display="inline-block"
      data-testid="fee-payable-at-property"
    >
      {isIncludedInTotal ? 'Includes' : 'Excludes'} fees of{' '}
      <Currency amount={payableAtProperty.amount} currency={payableAtProperty.currency} fontSize={['xs', 'sm']} fontWeight="bold" />
      {' '}payable in local currency on check-out
    </Box>
  );

OfferPayableAtProperty.propTypes = {
  payableAtProperty: PropTypes.shape({
    amount: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
  }).isRequired,
  isIncludedInTotal: PropTypes.bool.isRequired,
};

export default OfferPayableAtProperty;
